import type { PropsWithChildren } from 'react'
import { createContext, useContext, useState } from 'react'

type NavigateBillingModalProps = {
  isOpen: boolean
  close: Function
  open: Function
  feature?: string
}

const NavigateBillingModalContext =
  createContext<NavigateBillingModalProps | null>(null)

export function useNavigateBillingModal() {
  const state = useContext(NavigateBillingModalContext)

  if (!state) {
    throw new Error(
      'useNavigateBillingModal must be used within NavigateBillingModalProvider.',
    )
  }

  return state
}

export function NavigateBillingModalProvider({ children }: PropsWithChildren) {
  const [isOpen, setIsOpen] = useState(false)
  const [feature, setFeature] = useState<string>()
  const close = () => setIsOpen(false)
  const open = (feature: string) => {
    setIsOpen(true)
    setFeature(feature)
  }

  const value = {
    isOpen,
    close,
    open,
    feature,
    setFeature,
  }

  return (
    <NavigateBillingModalContext.Provider value={value}>
      {children}
    </NavigateBillingModalContext.Provider>
  )
}
